import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LegalTermsRestService {
  constructor(private http: HttpClient) {}

  getLegalContent(language: string) {
    return this.http.get(`assets/legal/${language}/legal_terms.html`, { responseType: 'text' });
  }
}